import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Col, Table, Modal } from 'react-bootstrap';

import { Typeahead } from 'react-bootstrap-typeahead';
import _ from 'lodash'
import '../css/main.css';
import { authContext } from '../AzureAd';

export default class MaintenanceAuditAppendModifyComponent extends React.Component {

	previousPage() {
		hashHistory.push("/auditingAppend");
	}

	componentDidMount() {
		this.props.findCategories();
	}

	componentWillMount() {
		this.props.findDetails(this.props.request.get("card"));
	}

	toSetDropDownOptions(category) {
		let ret = [];
		if (category && category.checkSets) {
			category.checkSets.map((ckSet, index) => {
				ret.push({ value: ckSet.id, label: ckSet.description, target: ckSet });
			});
		}
		return ret;
	}

	toItemDropDownOptions() {
		let checkSet = this.props.request.get('checkSet');

		let ret = [];
		if (checkSet && checkSet.checkItems) {
			checkSet.checkItems.map((item, index) => {
				if (item.show) {
					ret.push({ value: item.id, label: item.description, target: item });
				}
			});
		}
		return ret;
	}

	detailSets(details) {
		//ref ManageCheckItemComponent
		//1 . 分組 衣 褲 分組
		//sort by cat , by set

		//asyn 先 rendering
		if (details.size === 0) {
			return [];
		}

		let groups = _.groupBy(details, (item) => {
			return item.categoryId
		})

		let clothSets = _.sortBy(groups[1], (detail) => detail.checkSet.id);
		let pantSets = _.sortBy(groups[2], (detail) => detail.checkSet.id);

		let ret = [];
		ret.push(clothSets);
		ret.push(pantSets);
		return ret;
	}

	clothSet(details) {
		if (details.size === 0) {
			return [];
		}
		let gps = this.detailSets(details);
		if (gps[0].length > 0) {
			return gps[0];
		}
		return [];
	}
	pantSet(details) {
		if (details.size === 0) {
			return [];
		}
		let gps = this.detailSets(details);
		if (gps[1].length > 0) {
			return gps[1];
		}
		return [];
	}

	deleteDetail(detail) {
		this.props.deleteDetail(detail, this.props.response.get('card'));
	}

	appendCategoryDescription(category) {
		if (category) {
			return category.description;
		} else {
			return "";
		}
	}

	onCheckSetSelectedControl() {
		let ckSeet = this.props.request.get('checkSet');
		if (ckSeet) {
			return [{ value: ckSeet.id, label: ckSeet.description, target: ckSeet }];
		} else {
			return [];
		}
	}

	onCheckItemSelectedControl() {

		let ckItem = this.props.request.get('checkItem');
		if (ckItem) {
			return [{ value: ckItem.id, label: ckItem.description, target: ckItem }];
		} else {
			return [];
		}
	}

	disableCheckItemOptions() {
		if (this.props.request.get('checkSet')) {
			return false;
		} else {
			return true;
		}
	}

	disableAppendCheckItem() {
		return this.props.request.get('checkSet') == null || this.props.request.get('checkItem') == null;
	}

	appendCheckDetail(missingOrDamage) {

		let resp = this.props.response;
		let req = this.props.request;
		if (req.get("checkSet") == null || req.get("checkItem") == null) {
			alert("維修項目為必填選項!");
			return;
		}

		let desc = '';
		if ("DAMAGE" === missingOrDamage) {
			desc = " [免費] ";
		}

		let desc2 = '';
		if ('ESCAPE' === missingOrDamage) {
			desc2 = '[不需處理]';
		}

		let ans = confirm("確定" + desc + "新增" + desc2 + "維修選項 [ " + req.get("checkItem").description + ' ] ?');
		if (!ans) {
			return;
		}

		let epc;

		if (resp.get("category").id == 1) {
			epc = resp.get("card").clothEpc;
		}

		if (resp.get("category").id == 2) {
			epc = resp.get("card").pantEpc;
		}


		let editing = {
			cardPk: resp.get("card").id,
			categoryPk: resp.get("category").id,
			setPk: req.get("checkSet").id,
			itemPk: req.get("checkItem").id,
			note: req.get("note"),
			epc: epc,
			refineStatus: missingOrDamage,
			creator: authContext.getCachedUser().userName,
		};
		this.props.appendCheckDetail(editing);
	}

	render() {

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		function disableDeleteIcon(detail, card) {
			if (detail.status === 'AUDITED' || detail.refineStatus === "REMOVED") {
				return true;
			} else {
				return false;
			}
		}

		function deleteIcon(detail, card) {
			if (disableDeleteIcon(detail, card)) {
				return 'delete-grey.svg'
			} else {
				return 'delete.svg'
			}
		}

		let eraseIcon = (detail) => {
			if (detail.refineStatus === 'REMOVED') {
				return <img src='erase.svg' height="30" width="30" title="已取消維修建議" alt="" />;
			} else {
				return '';
			}
		}

		let appendIcon = (detail) => {
			if (detail.refineStatus === 'APPEND') {
				return <img src='cart.svg' height="30" width="30" title="新追加維修選項" alt="" />;
			} else if (detail.refineStatus === 'DAMAGE') {
				return <img src='fly-cash.svg' height="40" width="40" title="新追加維修選項(賠償)" alt="" />;
			} else if (detail.refineStatus === 'MISSING') {
				return <img src='money-bag.svg' height="30" width="30" title="新追加維修選項(遺漏)" alt="" />;
			} else if (detail.refineStatus === 'ESCAPE') {
				return <img src='cart.svg' height="30" width="30" title="新追加維修選項(不處理)" alt="" />;
			}
			else {
				return '';
			}
		}
		let eraseIconNote = (detail) => {
			if (detail.refineStatus === 'REMOVED') {
				return "已取消";
			} else {
				return '';
			}
		}
		let appendIconNote = (detail) => {

			if (detail.refineStatus === 'APPEND') {
				return "消防隊新追加";
			} else if (detail.refineStatus === 'DAMAGE') {
				return "損壞賠償";
			} else if (detail.refineStatus === 'MISSING') {
				return "漏檢追加";
			} else if (detail.refineStatus === 'ESCAPE') {
				return "追加(不維修)";
			}
			else {
				return '';
			}

		}

		let cardStatus = function (statusKey) {
			switch (statusKey) {
				case 'COMPLETED':
					return '完成清點';
				case 'MODIFIED':
					return '修改清點中';
				case 'REFINED':
					return '已確認';
				case 'FIXING':
					return '維修中';
				case 'FIXED':
					return '完成維修';
				case 'AUDITED':
					return '完成稽核';
				default:
					return "";
			}
		}

		let highlight = function (card) {
			let statusKey = card == null ? "NULL" : card.status;
			switch (statusKey) {
				case 'COMPLETED':
				case 'MODIFIED':
				case 'REFINED':
				case 'FIXING':
				case 'FIXED':
				case 'AUDITED':
					return {
						textAlign: "center",
					};
				default:
					return {};
			}
		}

		let highlightClassName = function (card) {
			let statusKey = card == null ? "NULL" : card.status;
			switch (statusKey) {
				case 'COMPLETED':
					return "highlight-blue";
				case 'MODIFIED':
					return "highlight-blue";
				case 'REFINED':
					return "highlight-red";
				case 'FIXING':
					return "highlight-red";
				case 'FIXED':
					return "highlight-red";
				case 'AUDITED':
					return "highlight-green";
				default:
					return "";
			}
		}

		return (
			<div><Col xs={12} sm={12} md={12}>

				<h4>
					檢點作業&nbsp;&gt;&gt;&nbsp;增補項目 &gt;&gt; 增補清點細項&nbsp;
					<a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<span hidden>MaintenanceAuditAppendModifyComponent </span>

				<table className="main">
					<tbody>
						<tr>
							<th width="14%">訂單編號</th>
							<td width="22%">{this.props.request.get("mcase").orderId}</td>
							<th width="14%">客戶名稱</th>
							<td width="22%">{this.props.request.get("mcase").customer.customerName}</td>
							<th width="14%">建立時間</th>
							<td width="14%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
						</tr>
						<tr>
							<th width="14%">維修卡號</th>
							<td width="22%" className={"highlight"} style={{ textAlign: "center" }} >{this.props.response.get("card").code}</td>
							<th width="14%">使用者名</th>
							<td width="22%">{this.props.response.get("card").owner}</td>
							<th width="14%">維修卡狀態</th>
							<td width="14%" style={highlight(this.props.response.get("card"))}
								className={highlightClassName(this.props.response.get("card"))}>{cardStatus(this.props.response.get("card").status)}</td>
						</tr>
					</tbody>
				</table>
				<br />

				<div hidden={this.props.response.get("card") && this.props.response.get("card").noClothes}>

					<Table striped bordered condensed hover >
						<thead>
							<tr>
								<th colSpan='5'><img alt='shirt' src='shirt.svg' height="40" width="40" />消防衣維修項目</th>
								<th style={{ verticalAlign: "middle" }}>Note</th>
								<th width="5%" style={alignCenter}><Button bsSize='small' bsStyle="warning"
									onClick={
										(event) => {
											this.props.showAppendModal(this.props.response.get('card'), this.props.categories[0]);
										}
									}
									disabled={this.props.response.get('card').clothesAudited}

								>+</Button></th>
							</tr>
						</thead>
						<tbody>
							{
								this.clothSet(this.props.response.get("details")).map(
									(detail, index) => {
										let card = this.props.response.get('card');

										return <tr key={index}>
											<td width="3%" style={alignCenter} >{index + 1}</td>
											<td width="5%" style={alignCenter}>{eraseIcon(detail)}{appendIcon(detail)}</td>
											<td width="15%">{detail.checkSet.description}</td>
											<td width="25%">{detail.checkItem.description}</td>
											<td width="10%" style={alignCenter}>{eraseIconNote(detail)}{appendIconNote(detail)}</td>
											<td>{detail.note}</td>
											<td width="5%" style={alignCenter}>
												<a >
													<Button disabled={disableDeleteIcon(detail, card)} onClick={
														(event) => {
															this.deleteDetail(detail);
														}
													} title="移除選項">
														<img src={deleteIcon(detail, card)} height="20" width="20" alt="" />
													</Button>
												</a>
											</td>
										</tr>
									}
								)
							}
						</tbody>
					</Table>
				</div>
				<br />
				<div hidden={this.props.response.get("card") && this.props.response.get("card").noPant}>

					<Table striped bordered condensed hover >
						<thead>
							<tr>
								<th colSpan='5'><img alt='shorts' src='shorts.svg' height="40" width="40" />消防褲維修項目</th>
								<th>Note</th>
								<th width="5%" style={alignCenter}><Button bsSize='small' bsStyle="warning"
									onClick={
										(event) => {
											this.props.showAppendModal(this.props.response.get('card'), this.props.categories[1]);
										}
									}
									disabled={this.props.response.get('card').pantAudited}
								>+</Button></th>
							</tr>
						</thead>
						<tbody>
							{
								this.pantSet(this.props.response.get("details")).map(
									(detail, index) => {
										let card = this.props.response.get('card');
										return <tr key={index}>
											<td width="3%" style={alignCenter} >{index + 1}</td>
											<td width="5%" style={alignCenter}>{eraseIcon(detail)}{appendIcon(detail)}</td>
											<td width="15%">{detail.checkSet.description}</td>
											<td width="25%">{detail.checkItem.description}</td>
											<td width="10%" style={alignCenter}>{eraseIconNote(detail)}{appendIconNote(detail)}</td>
											<td>{detail.note}</td>
											<td width="5%" style={alignCenter}>
												<a>
													<Button disabled={disableDeleteIcon(detail, card)} onClick={
														(event) => {
															this.deleteDetail(detail);
														}
													} title="移除選項">
														<img src={deleteIcon(detail, card)} height="20" width="20" alt="" />
													</Button>
												</a>
											</td>
										</tr>
									}
								)
							}
						</tbody>
					</Table>
				</div>
			</Col>

				<Modal show={this.props.response.get('show')} onHide={this.props.hideAppendModal} backdrop="static">
					<Modal.Header closeButton >
						<Modal.Title id="append-checked-item">追加清點項目</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<span hidden> MaintenanceAuditAppendModifyComponent.Modal </span>
						<h4>[{
							this.appendCategoryDescription(this.props.response.get('category'))
						}] 確認後追加清點項目</h4>

						<Table striped bordered condensed hover >
							<tbody>
								<tr>
									<th>&nbsp;&nbsp;維修類別</th>
									<td>
										<Typeahead
											onChange={(selecteds) => {
												if (selecteds[0]) {
													this.props.assignAppendSet(selecteds[0].target);
													this.itemOption.getInstance().clear();
												}
											}}
											options={this.toSetDropDownOptions(this.props.response.get('category'))}
											selected={this.onCheckSetSelectedControl()}
										//disabled
										/>
									</td>
								</tr>
								<tr>
									<th>&nbsp;&nbsp;清點細項</th>
									<td>
										<Typeahead
											ref={(ref) => this.itemOption = ref}
											clearButton
											onChange={(selecteds) => {
												if (selecteds[0]) {
													this.props.assignAppendItem(selecteds[0].target);
												}
											}}
											options={this.toItemDropDownOptions(this.props.request.get('checkSet'))}
											selected={this.onCheckItemSelectedControl()}
											disabled={this.disableCheckItemOptions()}
										/>
									</td>
								</tr>
								<tr>
									<th>&nbsp;&nbsp;附註</th>
									<td>
										<input type="text" className='form-control'
											onChange={(e) => {
												this.props.assignAppendNote(e.target.value);
											}}
											value={this.props.request.get('note')}
										/>
									</td>
								</tr>
								<tr>
									<th>&nbsp;&nbsp;</th>
									<td>
										<Button onClick={(event) => {
											this.appendCheckDetail("MISSING")
										}}
											disabled={this.disableAppendCheckItem()}
										>追加(收費 $)</Button>&nbsp;&nbsp;&nbsp;先前未檢查出項目<br />
										<Button onClick={(event) => {
											this.appendCheckDetail("DAMAGE")
										}}
											disabled={this.disableAppendCheckItem()}
										>追加(不收費)</Button>&nbsp;&nbsp;&nbsp;維修過程產生<br />
										<Button onClick={(event) => {
											this.appendCheckDetail("ESCAPE")
										}}
											disabled={this.disableAppendCheckItem()}
										>追加(不維修)</Button>&nbsp;&nbsp;&nbsp;先前未檢查出項目，但經費不足<br />
										<Button onClick={(event) => { this.props.hideAppendModal() }} >取消</Button>
									</td>
								</tr>
							</tbody>
						</Table>

					</Modal.Body>
					<Modal.Footer>
						<Button onClick={(event) => { this.props.hideAppendModal() }} >離開</Button>
					</Modal.Footer>
				</Modal>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceAuditAppendModifyComponent.jsx